import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Form, FormActions, FormInput } from '../../../components/form/index.js';
import { useUsersContext } from '../../../contexts/users.tsx';
import { UserLoginModel } from '../../../models/users/userLoginModel.ts';

const validationSchema = Yup.object().shape({
    userName: Yup.string().required('Username is required'),
    password: Yup.string().required('Password is required'),
});

const LoginBody = () => {
    const { login } = useUsersContext();
    const navigate = useNavigate();
    const [userLoginModel, setUserLoginModel] = useState<UserLoginModel>({ userName: '', password: '' } as UserLoginModel);
    const [errors, setErrors] = useState<Record<string, string>>({});

    const handleInputChange = (e: any) => {
        const { id, value } = e.target;
        setUserLoginModel((prevData) => ({
            ...prevData,
            [id]: value, // Update the corresponding field in state
        }));

        validationSchema
            .validateAt(id, { ...userLoginModel, [id]: value })
            .then(() => setErrors((prev) => ({ ...prev, [id]: '' })))
            .catch((err) => setErrors((prev) => ({ ...prev, [id]: err.message })));
    };

    const handleSubmit = () => {
        validationSchema
            .validate(userLoginModel, { abortEarly: false })
            .then(() => {
                login(userLoginModel);
            })
            .catch((err) => {
                const validationErrors: Record<string, string> = {};
                err.inner.forEach((error: Yup.ValidationError) => {
                    if (error.path) validationErrors[error.path] = error.message;
                });
                setErrors(validationErrors);
            });
    };

    return (
        <Form>
            <FormInput entity={userLoginModel} handleInputChange={handleInputChange} fieldName='userName' label='Username' errors={errors} />
            <FormInput entity={userLoginModel} handleInputChange={handleInputChange} fieldName='password' label='Password' errors={errors} />
            <FormActions
                mainAction={handleSubmit}
                mainActionText={"Login"}
                secondaryAction={() => navigate("/register")}
                secondaryActionText={"Register"}
                overrideIsLoggedIn={true} />
        </Form>
    );
};

export default LoginBody;